import * as Components from "./components";

const main = () => {
  if (typeof document === `undefined` || typeof window === `undefined`) {
    return;
  }

  document.addEventListener(`DOMContentLoaded`, () => {
    document.querySelectorAll(`[data-component]`).forEach((element) => {
      const componentId = element.getAttribute(`data-component`);

      if (typeof Components?.[componentId] === `function`) {
        Components[componentId](element);
      }
    });
  });
};

main();
